export enum StateStatus {
  Initial = 'INITIAL',
  Busy = 'BUSY',
  Loaded = 'LOADED',
  Error = 'ERROR'
}
